export const heroOrange = "#C76A3C";
export const buttonOrangeDark = "#AC552B";
export const logoOrange = "#ED8A00";
export const white = "#FFFFFF";
export const medGray = "#979797";
export const gray1 = "#ECECEC";
export const gray2 = "#E2E2E2";
export const gray4 = "#E9E9E9";
export const textDark = "#5B5D62";
export const taupe = "#A59F91";
export const textDarkest = "#5b5d62";
